import { IconComponentImage } from '@lessonup/ui-components';
import React from 'react';
import { PinComponentPlaceholder } from '../../components/PinComponentPlaceholder';

export interface ImagePinComponentPlaceholderProps {
  style?: React.CSSProperties;
  onDoubleClick?(): void;
}

export const ImagePinComponentPlaceholder: React.FC<ImagePinComponentPlaceholderProps> = ({ style, onDoubleClick }) => {
  return (
    <PinComponentPlaceholder style={style} onDoubleClick={onDoubleClick}>
      <IconComponentImage color="#848991" />
    </PinComponentPlaceholder>
  );
};
